const DarkCircleCloseIcon = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width='24' height='24' rx='12' fill='#ffffff' />
      <path
        d='M7.41455 7.41455L16.5858 16.5858'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M7.41455 16.5857L16.5858 7.41444'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default DarkCircleCloseIcon;
